import React from "react";
import "./Home.css";
import { GiFarmer } from "react-icons/gi";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { FaIndustry, FaMapMarkerAlt } from "react-icons/fa";
import Counter from "./Counter";


function Home({ setCurrentPage }) {
  const stats = [
    { target: 15, suffix: "+", label: "Years Experience" },
    { target: 500, suffix: "+", label: "Farmers Served" },
    { target: 14, suffix: "+", label: "Awards Won" },
    { target: 14, suffix: "+", label: "Partner Companies" }
  ];

  const features = [
    { icon: <RiVerifiedBadgeFill color="#10b981" />, title: "100% Original", desc: "Direct from manufacturer, no fakes" },
    { icon: <FaIndustry color="#475569" />, title: "14+ Brands", desc: "All major agro companies" },
    { icon: <GiFarmer color="#2d5a27" />, title: "Farmer First", desc: "Expert guidance always" },
    { icon: <FaMapMarkerAlt color="#ef4444" />, title: "Local & Trusted", desc: "Serving Bhavnagar for years" }
  ];

  const companies = [
    "Swal Corporation",
    "IIL India",
    "Heranba Industries",
    "Sumitomo Chemical",
    "GSP Crop Science",
    "Corteva Pioneer",
    "FMC India",
    "Mahalaxmi Crop Science",
    "Avirat Crop Science",
    "Kartavya Seeds",
    "Vishwas Agri Seeds",
    "Ichiban Crop Science"
  ];

  const testimonials = [
    {
      stars: "★★★★★",
      quote: "Been buying from Vinayak for 10 years. Always original products and best advice.",
      author: "Ramesh Patel",
      location: "Sihor, Gujarat"
    },
    {
      stars: "★★★★★",
      quote: "Jaydip bhai always guides us which chemical is best for our crop.",
      author: "Hasmukh Mer",
      location: "Bhavnagar"
    },
    {
      stars: "★★★★★",
      quote: "Best agro shop in Bhavnagar. Seeds always fresh.",
      author: "Bharat Patel",
      location: "Mahuva, Gujarat"
    }
  ];

  return (
    <div className="home-container">
      {/* Hero Section */}
      <header className="hero-section">
        <div className="hero-video-container">
          <video autoPlay loop muted playsInline className="hero-video">
            <source src="/assets/add.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title animate-fade-in">Vinayak Agro Chemicals</h1>
          <p className="hero-subtitle animate-slide-up">Your Trusted Partner in High-Yield Farming</p>
          <p className="hero-description animate-slide-up">
            Distributors: Pesticides · Hybrid Seeds · Fertilizer · Bhavnagar, Gujarat. Providing 100% original products to empower farmers.
          </p>
          <div className="hero-buttons animate-slide-up">
            <button onClick={() => setCurrentPage("products")} className="hero-btn primary-btn">
              View Products
            </button>
            <button onClick={() => setCurrentPage("contact")} className="hero-btn secondary-btn">
              Contact Us
            </button>
          </div>
        </div>
      </header>

      {/* Stats Strip */}
      <section className="stats-strip">
        <div className="stats-container">
          {stats.map((stat, idx) => (
            <div key={idx} className="stat-card">
              <div className="stat-number">
                <Counter target={stat.target} suffix={stat.suffix} />
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <div className="section-header">
          <span className="section-tag">Value Proposition</span>
          <h2 className="section-title">Why Choose Us</h2>
        </div>
        <div className="features-grid">
          {features.map((feat, idx) => (
            <div key={idx} className="why-card">
              <div className="why-icon">{feat.icon}</div>
              <h3 className="why-title">{feat.title}</h3>
              <p className="why-desc">{feat.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Partner Companies (Infinite Auto-Scroll Marquee) */}
      <section className="partners-marquee-section">
        <div className="section-header">
          <span className="section-tag" style={{ color: "#81c784" }}>Partners</span>
          <h2 className="section-title" style={{ color: "#ffffff" }}>Our Partner Companies</h2>
        </div>
        <div className="marquee-wrapper">
          <div className="marquee-track">
            {/* Render list twice to ensure seamless continuous scrolling loop */}
            {companies.concat(companies).map((company, idx) => (
              <div key={idx} className="marquee-chip">
                {company}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="section-header">
          <span className="section-tag">Social Proof</span>
          <h2 className="section-title">What Farmers Say</h2>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testi, idx) => (
            <div key={idx} className="testimonial-card">
              <div className="stars">{testi.stars}</div>
              <p className="testimonial-quote">"{testi.quote}"</p>
              <div className="testimonial-meta">
                <span className="testimonial-author">{testi.author}</span>
                <span className="testimonial-loc">{testi.location}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
